import React from 'react';
import { Gauge } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid, Steps } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function MarginLendingPage() {
  const module = getModule('margin-lending')!;
  return (
    <ModulePageLayout module={module} Icon={Gauge}>
      <Section title="Leveraged Trading, Backed by Your Crypto">
        <p className="text-gray-700 leading-relaxed">
          Crypto Margin Lending lets you borrow against your crypto holdings to trade with leverage —
          2x to 10x — with smart contract integration enforcing the terms automatically.
        </p>
      </Section>

      <Section title="How a Margin Loan Works">
        <Steps
          items={[
            'Lock crypto as collateral with a defined lock and unlock date.',
            'Open a margin loan: amount, collateral amount, leverage level, LTV ratio, interest rate, and due date are all fixed upfront.',
            'Your loan-to-value ratio is monitored in real time. Breach a safe threshold and an automated margin call is triggered.',
            "Add collateral or repay part of the loan within the timeframe — or the position is liquidated and the collateral sold.",
          ]}
        />
      </Section>

      <Section title="Trading & Risk Controls">
        <FeatureGrid
          items={[
            { title: 'Order Types', body: 'Market, Limit, and Stop orders, with full lifecycle tracking from open through filled or cancelled.' },
            { title: 'Short Selling', body: 'Buy, Sell, or Short Sell — margin loans can support directional bets in either direction.' },
            { title: 'Separate KYC Layer', body: 'Margin trading may require additional verification beyond standard account KYC.' },
            { title: 'Executed Trade Records', body: 'Every fill records price, quantity, and fees for full transparency on your trading history.' },
          ]}
        />
      </Section>
    </ModulePageLayout>
  );
}
